import { AppBar, Box, Button, ButtonBase, Container, Hidden, IconButton, Toolbar, Tooltip } from '@material-ui/core';
import DarkModeIcon from '@material-ui/icons/Brightness3';
import LightModeIcon from '@material-ui/icons/WbSunny';
import clsx from 'clsx';
import { Link } from 'components';
import { ProfileMenu } from 'components/profile-menu';
import { logoTextBlack, logoTextWhite } from 'config';
import { useAuth } from 'context/AuthContext';
import { useNotifications } from 'context/NotificationsContext';
import { useSettings } from 'context/SettingsContext';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageMenu } from './components/language-menu';
import { HeaderMenu } from './header-menu';
import { HeaderMenuMobile } from './header-menu-mobile';
import { useStyles } from './header.style';

export const Header: React.FC = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { notify } = useNotifications();
    const { user, isLoggedIn, removeAuthData, openModal } = useAuth();
    const { isDarkMode, toggleTheme } = useSettings();
    const [scrolledDown, setScrolledDown] = useState(false);

    const logOut = (): void => {
        removeAuthData();

        notify({
            type: 'success',
            message: t('auth:logout'),
        });
    };

    const handleScroll = () => {
        if (window.scrollY > 10) {
            setScrolledDown(true);
        } else {
            setScrolledDown(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <AppBar className={clsx(classes.appBar, scrolledDown && classes.shadow)} elevation={0}>
            <Container maxWidth="lg" style={{ height: '100%' }}>
                <Toolbar className={classes.toolbar}>
                    <Link style={{ width: 'unset' }} to="/">
                        <ButtonBase disableRipple>
                            <div className={classes.logoContainer}>
                                <img
                                    style={{ width: '102px', height: '38px' }}
                                    src={isDarkMode ? logoTextWhite : logoTextBlack}
                                    alt="staffy logo"
                                />
                            </div>
                        </ButtonBase>
                    </Link>
                    <Box flexGrow={1}>
                        <HeaderMenu />
                    </Box>
                    <LanguageMenu />
                    <HeaderMenuMobile />
                    <Hidden smDown>
                        <Box display="flex" alignItems="center">
                            {!isLoggedIn && (
                                <Tooltip
                                    title={
                                        isDarkMode ? (t('header:lightTheme') as string) : t('header:darkTheme') || ''
                                    }
                                    placement="bottom"
                                    arrow
                                >
                                    <IconButton size="small" onClick={toggleTheme} className={classes.icon}>
                                        {isDarkMode ? (
                                            <LightModeIcon style={{ fill: 'orange' }} />
                                        ) : (
                                            <DarkModeIcon style={{ transform: 'rotate(45deg) translate(3px, 0px)' }} />
                                        )}
                                    </IconButton>
                                </Tooltip>
                            )}
                            {!isLoggedIn && (
                                <Button
                                    onClick={openModal}
                                    color="primary"
                                    variant="outlined"
                                    className={classes.loginButton}
                                >
                                    {t('header:login')}
                                </Button>
                            )}
                        </Box>
                    </Hidden>
                    {isLoggedIn && <ProfileMenu user={user} logOut={logOut} />}
                </Toolbar>
            </Container>
        </AppBar>
    );
};
